const getFieldCSSClasses = (touched: any, errors: any) => {
  const classes = ['form-control']
  /*if (touched && errors) {
    classes.push('is-invalid')
  }

  if (touched && !errors) {
    classes.push('is-valid')
  }*/

  return classes.join(' ')
}

export function Input({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  type = 'text',
  extraText,
  numericOnly = false,
  ...props
}: any) {
  return (
    <>
      {label && <label className={extraText && 'mb-0'}>Enter {label}</label>}
      {extraText && <p className="text-muted font-weight-light">{extraText}</p>}
      <input
        type={type}
        {...field}
        {...props}
        onChange={(e: any) => {
          if (!numericOnly) {
            field.onChange(e)
            return
          }
          const digitsOnly = e.target.value.replace(/\D+/g, '');
          e.target.value = digitsOnly;
          field.onChange(e);
        }}
        className={`${getFieldCSSClasses(touched[field.name], errors[field.name])} form-control`}
      />
    </>
  )
}